<div class="content body-m" [innerHTML]="text"></div>